import { render, staticRenderFns } from "./OmsTable.vue?vue&type=template&id=0775b292&scoped=true"
import script from "./OmsTable.vue?vue&type=script&lang=js"
export * from "./OmsTable.vue?vue&type=script&lang=js"
import style0 from "./OmsTable.vue?vue&type=style&index=0&id=0775b292&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0775b292",
  null
  
)

export default component.exports